export enum FileManagementSortBy {
    None = 0,
    NameAsc = 1,
    NameDesc = 2,
    FileItemAsc = 3,
    FileItemDesc = 4,
    FileSizeAsc = 5,
    FileSizeDesc = 6,
    UploadDateAsc = 7,
    UploadDateDesc = 8,
  }